export const CHANGE_USER_INPUT = 'change-user-input';
const changeUserInput = ({ userInput }) => ({ type: CHANGE_USER_INPUT, payload: { userInput } });
export default changeUserInput;
